import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Content from '../Content/Content';
import useStyles from './FeatureBanner.styles';
import { Box, useMediaQuery } from '@mui/material';
import GenericImage from '../GenericImage/GenericImage';
import { SiteContext } from '../../../../ui-components/src/utils/common';
import { useBackgroundClass } from '../../styles/jss/utils';
import clsx from 'clsx';
const FeatureBanner = (props) => {
    var _a;
    const { headingTag = 'H3', image, darknessLevel, textContentPosition = 'TOP', backgroundAndHeaderTextColors } = props;
    const { isFlyingFlowers } = useContext(SiteContext);
    const isTablet = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [backgroundColor, headingColor] = ((_a = backgroundAndHeaderTextColors === null || backgroundAndHeaderTextColors === void 0 ? void 0 : backgroundAndHeaderTextColors.split('-')) !== null && _a !== void 0 ? _a : []).map((color) => color.trim());
    const isFromDeliveryPass = props.isDeliveryPassInnerContentClass || false;
    const { classes } = useStyles({ headingColor, isFromDeliveryPass });
    const textContentPositionClasses = {
        BOTTOM: classes.positionBottom,
        TOP: classes.positionTop,
        CENTER: classes.positionCenter,
    };
    const { bgClass } = useBackgroundClass(backgroundColor);
    const isFfOrDeliveryPass = isFlyingFlowers || isFromDeliveryPass;
    return (_jsxs(Box, { className: clsx(classes.container, !isFfOrDeliveryPass && bgClass), children: [_jsx(GenericImage, { classNames: [classes.image], image: image, renderSquareImage: true, renderSquaredImagesOptions: true, darknessLevel: darknessLevel, addDarkness: !isFfOrDeliveryPass && isTablet }), _jsx(Content, Object.assign({}, props, { headingTag: headingTag, messageClasses: [classes.newMessage], headingClasses: [classes.heading], containerClasses: [classes.contentContainer], contentInnerClasses: [
                    !isFfOrDeliveryPass ? classes.contentInner : '',
                    !isFfOrDeliveryPass ? textContentPositionClasses[textContentPosition] : '',
                    props.isDeliveryPassInnerContentClass ? classes.innerContentDeliveryPassCard : '',
                ], wrapText: !isFfOrDeliveryPass, showLeadingAndTrailingLineBreaksForHeading: !isFfOrDeliveryPass, textAlignment: 'CENTER' }))] }));
};
export default FeatureBanner;
